import { __decorate } from 'tslib';
import { NgZone, ɵɵdefineInjectable, ɵɵinject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
var FramesDelay_1;
// @dynamic
let FramesDelay = FramesDelay_1 = class FramesDelay {
    constructor(
    // Dependencies
    ngZone) {
        this.ngZone = ngZone;
        FramesDelay_1.instance = this;
    }
    // Delay
    delay$(frames = 0) {
        return (new Observable(subscriber => {
            const run = () => {
                let currentRAF;
                const waitFrames = (framesLeft, callback) => {
                    if (framesLeft > 0)
                        currentRAF = requestAnimationFrame(() => waitFrames(framesLeft - 1, callback));
                    else
                        callback();
                };
                // When `waitFrames` is invoked and the `framesLeft` parameter is 0, the delay is considered fulfilled
                // and the callback is invoked.
                //
                // We are incrementing the amount of frames passed, so that 0 will mean the immediate next frame, 1
                // will mean 1 frame after the next frame, and so on.
                waitFrames(frames + 1, () => {
                    const fulfill = () => {
                        subscriber.next();
                        subscriber.complete();
                    };
                    if (this.ngZone)
                        this.ngZone.run(fulfill);
                    else
                        fulfill();
                });
                return { unsubscribe: () => currentRAF && cancelAnimationFrame(currentRAF) };
            };
            if (this.ngZone)
                this.ngZone.runOutsideAngular(run);
            else
                run();
        })).pipe(first());
    }
    static get delay$() {
        if (!FramesDelay_1.instance)
            FramesDelay_1.instance = new FramesDelay_1();
        return FramesDelay_1.instance.delay$;
    }
};
FramesDelay.ɵfac = function FramesDelay_Factory(t) { return new (t || FramesDelay)(ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
FramesDelay.ctorParameters = () => [
    { type: NgZone }
];
FramesDelay.ɵprov = ɵɵdefineInjectable({ factory: function FramesDelay_Factory() { return new FramesDelay(ɵɵinject(NgZone)); }, token: FramesDelay, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FramesDelay, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, null); })();

/*
 * Public API Surface of angular-frames-delay
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FramesDelay };

